<template>
  <nav
    :class="$style.root"
  >
    <i18n-link
      :class="$style.link"
      :data-current="!hasImagesQuery ? '' : null"
      :to="routeObject()"
    >
      {{ $t('shared.listView') }}
    </i18n-link>
    <i18n-link
      :class="$style.link"
      :data-current="hasImagesQuery ? '' : null"
      :to="routeObject('images')"
    >
      {{ $t('shared.images') }}
    </i18n-link>
  </nav>
</template>

<script lang="ts" setup>
const route = useRoute()
const routeObject = (query: string) => {
  return {
    name: 'editions-slug-index-participants',
    params: {
      slug: route?.params?.slug
    },
    query: {
      view: query
    }
  }
}

const hasImagesQuery = computed(() => {
  return route?.query?.view === 'images'
})
</script>

<style module lang="scss">
.root {
  composes: container from global;
  margin-bottom: var(--unit--vertical);

  display: flex;
  justify-content: flex-end;
  gap: var(--stroke--default);

  @media (max-width: $breakpoint-s) {
    justify-content: center;
  }
}

.link {
  composes: reset-link button-rectangular from global;
}
</style>
